var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spacer",style:({ width: '100%', height: `calc(var(--mpadding) * ${_vm.num || 1})` })})
}
var staticRenderFns = []

export { render, staticRenderFns }